<template>
  <div class="template">
    
    <div class="redline"></div>
    <div class="top-title">轮胎保障服务函</div>
    <div class="num-con">
      编号：
      <span class="num">{{showDate.saleslip.pnum}}</span>
    </div>
    <table class="temTable" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td>
          <div class="p-content">
            兹证明
            <span class="key">“青岛鑫诚泰网络科技有限公司”</span>销售的
            <span class="key">轮胎保障服务</span>
            由中国人寿财产股份有限公司青岛市分公司（下称该公司）承保，服务细节如下：
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">一.服务期限：</div>
          <div
            class="p-content"
          >自服务生效之日起{{swapper(selectYear)}}年有效。在服务期限内，如发生车辆转让，原保服务任立即中止，且应立即通知本公司办理变更手续。变更手续办理的次日零时起，服务责任恢复，但原保单终止日期不变。服务责任中止期间本公司不负责赔偿。</div>
        </td>
      </tr>
      <tr>
        <td>
          <span class="key">二.服务范围：</span>1.轮胎使用车辆必须是中华人民共和国境内（不含港、澳、台）的7座及7座以下非营运车辆；2.轮胎使用车辆必须是汽车经销商在30天内销售的初次登记的新车。
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">三.服务责任：</div>
          <div class="p-content">
            1.在保障服务载明的保障期间，轮胎在车辆正常使用过程中出现保障服务约定范围内的轮胎单独损坏，根据本保障服务约定，对保障服务承担的轮胎更换费用，在本服务载明的赔偿限额内负责赔偿。<br>
            </div><div class="p-content">2.事故类型：鼓包：轮胎胎肩，胎侧部位有明显可见起鼓现象，爆胎：轮胎在极短的时间因破裂导致气压突然流失，裂口成不规则撕裂状。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">四.除外责任：</div>
          <div class="p-content">
            1. 客户的任何欺诈、不诚实或犯罪行为、故意行为、重大过失；2. 因自然磨损、腐蚀、人为损害、保管不当等可归咎于第三方的原因；3. 地震、雷击、火灾、爆炸、暴雨、洪水、台风等自然灾害；4. 除轮胎本身价值赔付责任以外的任何人身伤亡、财产损失及相关费用或责任；5. 非轮胎单独损坏导致的损失及相关费用或责任；6. 轮胎检测、运输费用；7. 罚款、违约金、惩罚性赔款；8. 因轮胎损坏造成的一切间接损失；9. 消费者从第三方已获得的赔偿或补偿；10. 轮胎的识别码因被破坏、移除、磨损或其他原因导致无法进行识别的；11. 轮胎被营运车辆使用，或被非营运车辆用于提供有偿服务时使用；12. 轮胎被盗、被遗弃或其他任何原因导致无法回收轮胎的；13. 轮胎裂纹，14. 因交通意外、轮胎安装错误、超速货超载行驶、过高或过低胎压等原因导致的轮胎损坏；15.出现事故时，轮胎纹理磨损达到或已超过磨损线；16. 轮胎曾被修补过；17.其他不属于本合同范围的一切损失费用和责任，销售商不负责赔偿。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">五.赔偿处理：</div>
          <div class="p-content">自新车购买之日起一年内：赔付轮胎实际入库价*100%</div>
          <div class="p-content">每条轮胎限赔付1次，每次只能赔付1条轮胎。 </div>
          <div class="p-content">特别声明：本保障服务赔偿不折现，需到制定经销商处换胎（不含更换轮胎时所产生的任何费用）。若新更换的轮胎与原报废轮胎存在差额，有经销商与车主自行解决。</div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">六.赔偿须知：</div>
          <div class="p-content">1．发生约定的轮胎事故后，客户应在48小时内通过4006601517，进行报案，等待审核。</div>
<div class="p-content">2．客户需要提交以下证明材料：</div>
<div class="p-content">（1）事故轮胎（鼓包或爆胎）在车辆方位的照片（45°角拍摄，含车牌号）</div>
<div class="p-content">（2）事故轮胎（鼓包或爆胎）侧面（能显示轮胎品牌、规格、DOT号和批次）与本车行驶证一起的照片</div>
<div class="p-content">（3）事故轮胎（鼓包或爆胎）侧面（能显示轮胎品牌、规格、DOT号和批次）与驾驶证一起的照片</div>
<div class="p-content">（4）事故轮胎（鼓包或爆胎）具体位置特写与本车行驶证一起的照片。</div>
<div class="p-content">3. 审核通过后，客服告知客户在30天内到制定的经销商处更换新轮胎。</div>
<div class="p-content">4. 更换完毕后，赔偿结束，因其他因素造成价格差额的，由客户自理。</div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">七．服务方式</div>
          <div class="p-content">1.服务商名称：青岛鑫诚泰网络科技有限公司</div>
          <div class="p-content">2.轮胎保证服务客服热线：400-660-1517</div>
        </td>
      </tr>
    </table>
    <p
      class="tips"
    >经销商盖章&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客户签名：</p>
    <p class="tips">日期:{{$formatTimeCN2(showDate.saleslip.pstarttime)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日期:{{$formatTimeCN2(showDate.saleslip.pstarttime)}}</p>
    
    <img class="inis3" src="@/assets/images/inis2-2.png" alt />
    <div class="personal-title">客户信息表</div>
    <table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td width="80">客户信息</td>
        <td width="90">客户名称</td>
        <td >{{showDate.saleslip.customername}}</td>
        <td width="90">登记日期</td>
        <td >{{this.$formatTimeCN(showDate.saleslip.buytime, 'yyyy-MM-dd')}}</td>
        <td width="130">证件号码</td>
        <td >{{showDate.saleslip.certificatenum}}</td>
      </tr>
       <tr>
        <td width="80" rowspan="2">车辆信息</td>
        <td width="90">车辆品牌</td>
        <td >{{showDate.saleslip.carbrand}}</td>
        <td width="90">车辆型号</td>
        <td >{{showDate.saleslip.carsys}}</td>
        <td width="130">联系电话</td>
        <td >{{showDate.saleslip.phone}}</td>
      </tr>
       <tr>
        <td width="90">车牌号码</td>
        <td >{{showDate.saleslip.carnum}}</td>
        <td width="90">VIN码</td>
        <td colspan="3">{{showDate.saleslip.frame}}</td>
      </tr>

      <tr>
      <td width="80" rowspan="12">轮胎信息</td>
      <td width="90" rowspan="3">左前轮</td>
        <td>品牌</td>
        <td >{{showDate.saleslip.tyreSsinfo.lfbrandname}}</td>
        <td>规格</td>
        <td colspan="2">{{showDate.saleslip.tyreSsinfo.lfgg}}</td>
      </tr>
      <tr>
        <td>生产批次</td>
        <td >{{showDate.saleslip.tyreSsinfo.lfpc}}</td>
        <td>DOT号</td>
        <td colspan="2">{{showDate.saleslip.tyreSsinfo.lfdot}}</td>
      </tr>
    <tr>
        <td>最高赔偿限额</td>
        <td colspan="4">{{showDate.saleslip.tyreSsinfo.lfamount}}</td>
      </tr>

      <tr>
      <td width="90" rowspan="3">右前轮</td>
        <td>品牌</td>
        <td >{{showDate.saleslip.tyreSsinfo.rfbrandname}}</td>
        <td>规格</td>
        <td colspan="2">{{showDate.saleslip.tyreSsinfo.rfgg}}</td>
      </tr>
      <tr>
        <td>生产批次</td>
        <td >{{showDate.saleslip.tyreSsinfo.rfpc}}</td>
        <td>DOT号</td>
        <td colspan="2">{{showDate.saleslip.tyreSsinfo.rfdot}}</td>
      </tr>
    <tr>
        <td>最高赔偿限额</td>
        <td colspan="4">{{showDate.saleslip.tyreSsinfo.rfamount}}</td>
      </tr>

      <tr>
      <td width="90" rowspan="3">左后轮</td>
        <td>品牌</td>
        <td >{{showDate.saleslip.tyreSsinfo.lbbrandname}}</td>
        <td>规格</td>
        <td colspan="2">{{showDate.saleslip.tyreSsinfo.lbgg}}</td>
      </tr>
      <tr>
        <td>生产批次</td>
        <td >{{showDate.saleslip.tyreSsinfo.lbpc}}</td>
        <td>DOT号</td>
        <td colspan="2">{{showDate.saleslip.tyreSsinfo.lbdot}}</td>
      </tr>
    <tr>
        <td>最高赔偿限额</td>
        <td colspan="4">{{showDate.saleslip.tyreSsinfo.lbamount}}</td>
      </tr>

      <tr>
      <td width="90" rowspan="3">右后轮</td>
        <td>品牌</td>
        <td >{{showDate.saleslip.tyreSsinfo.rbbrandname}}</td>
        <td>规格</td>
        <td colspan="2">{{showDate.saleslip.tyreSsinfo.rbgg}}</td>
      </tr>
      <tr>
        <td>生产批次</td>
        <td >{{showDate.saleslip.tyreSsinfo.rbpc}}</td>
        <td>DOT号</td>
        <td colspan="2">{{showDate.saleslip.tyreSsinfo.rbdot}}</td>
      </tr>
    <tr>
        <td>最高赔偿限额</td>
        <td colspan="4">{{showDate.saleslip.tyreSsinfo.rbamount}}</td>
      </tr>

      <tr>
      <td width="80" rowspan="2">经销商</td>
      <td width="90" >经销商名称</td>
      <td colspan="2">{{showDate.saleslip.jxsname}}</td>
        <td>联系方式</td>
        <td colspan="2">{{showDate.saleslip.jxsphone}}</td>
      </tr>
      <tr>
      <td width="90" >地址</td>
      <td colspan="5">{{showDate.saleslip.jxsaddr}}</td>
      </tr>

      <tr>
      <td width="80" rowspan="2">服务信息</td>
      <td width="90" >保障金额</td>
      <td colspan="2">{{showDate.saleslip.servicenum}}</td>
        <td>录入时间</td>
        <td colspan="2">{{$formatTimeCN2(showDate.saleslip.pstarttime)}}</td>
      </tr>
      <tr>
      <td width="90" >总赔偿限额</td>
      <td >{{showDate.saleslip.servicetotalamount}}</td>
        <td>有效日期</td>
        <td colspan="3">自{{$formatTimeCN2(showDate.saleslip.pstarttime)}}零时起至{{getendTime($formatTimeCN2(showDate.saleslip.pstarttime))}}24时止</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ["showDate", "selectYear"],
  data() {
    return {};
  },
  mounted() {
    // this.ini ()
  },
  methods: {
    swapper(n) {
      switch (n) {
        case 1:
          return "壹";
        case 2:
          return "贰";
        case 3:
          return "叁";
        case 4:
          return "肆";
        case 5:
          return "伍";
      }
    },
    getendTime(str) {
      str = str.split("年");
      let tempdata = Number(str[0]);
      str[0] = tempdata += this.selectYear;
      return str.join("年");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/template/luntai1.vue